import React from 'react';
import {
  Box,
  // Typography,
  // Paper,
  // Stack,
  // Fade,
  // useMediaQuery,
  // useTheme,
} from '@mui/material';
// import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
// import StorefrontIcon from '@mui/icons-material/Storefront';

const RegistrationRequiredPage = () => {
  // const theme = useTheme();
  //const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        // 100dvh is the secret for mobile. It accounts for mobile browser address bars.
        height: '100dvh',
        width: '100vw',
        background: 'white',
        // background: 'linear-gradient(180deg, #001665 0%, #000b33 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
        overflow: 'hidden', // Strictly prevents scrolling
        position: 'fixed',
        top: 0,
        left: 0,
      }}
    >
      {/*<Fade in timeout={800}>*/}
      {/*  <Paper*/}
      {/*    sx={{*/}
      {/*      p: isSmallMobile ? 3 : 5, // Tighter padding on small phones*/}
      {/*      borderRadius: 8,*/}
      {/*      textAlign: 'center',*/}
      {/*      maxWidth: 400,*/}
      {/*      width: '100%',*/}
      {/*      boxShadow: '0 20px 60px rgba(0,0,0,0.6)',*/}
      {/*      position: 'relative',*/}
      {/*      overflow: 'hidden',*/}
      {/*      // Prevents the card from being taller than the screen on tiny devices*/}
      {/*      maxHeight: '90dvh',*/}
      {/*      display: 'flex',*/}
      {/*      flexDirection: 'column',*/}
      {/*      justifyContent: 'center',*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    /!* Top accent bar *!/*/}
      {/*    <Box*/}
      {/*      sx={{*/}
      {/*        position: 'absolute',*/}
      {/*        top: 0,*/}
      {/*        left: 0,*/}
      {/*        right: 0,*/}
      {/*        height: 6,*/}
      {/*        bgcolor: '#ff9800',*/}
      {/*      }}*/}
      {/*    />*/}

      {/*    <Stack spacing={isSmallMobile ? 2 : 3} alignItems="center">*/}
      {/*      <Box*/}
      {/*        sx={{*/}
      {/*          width: isSmallMobile ? 60 : 80,*/}
      {/*          height: isSmallMobile ? 60 : 80,*/}
      {/*          bgcolor: '#fff3e0',*/}
      {/*          borderRadius: '50%',*/}
      {/*          display: 'flex',*/}
      {/*          alignItems: 'center',*/}
      {/*          justifyContent: 'center',*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        <AppRegistrationIcon*/}
      {/*          sx={{ fontSize: isSmallMobile ? 35 : 45, color: '#ff9800' }}*/}
      {/*        />*/}
      {/*      </Box>*/}

      {/*      <Typography*/}
      {/*        variant="h5"*/}
      {/*        sx={{*/}
      {/*          fontWeight: 800,*/}
      {/*          color: '#001665',*/}
      {/*          fontSize: isSmallMobile ? '1.2rem' : '1.5rem',*/}
      {/*          lineHeight: 1.2,*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        Registration Required*/}
      {/*      </Typography>*/}

      {/*      <Typography*/}
      {/*        variant="body1"*/}
      {/*        sx={{*/}
      {/*          color: '#555',*/}
      {/*          lineHeight: 1.4,*/}
      {/*          fontSize: isSmallMobile ? '0.85rem' : '1rem',*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        We couldn't find an active security pass on this device. For*/}
      {/*        secure entry, you must first register.*/}
      {/*      </Typography>*/}

      {/*      <Box*/}
      {/*        sx={{*/}
      {/*          width: '100%',*/}
      {/*          p: 2,*/}
      {/*          bgcolor: '#fdf7f0',*/}
      {/*          borderRadius: 4,*/}
      {/*          border: '1px dashed #ff9800',*/}
      {/*          display: 'flex',*/}
      {/*          alignItems: 'center',*/}
      {/*          gap: 1.5,*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        <StorefrontIcon*/}
      {/*          sx={{ color: '#ff9800', fontSize: isSmallMobile ? 20 : 24 }}*/}
      {/*        />*/}
      {/*        <Typography*/}
      {/*          variant="body2"*/}
      {/*          sx={{*/}
      {/*            textAlign: 'left',*/}
      {/*            fontWeight: 600,*/}
      {/*            color: '#855c00',*/}
      {/*            fontSize: isSmallMobile ? '0.75rem' : '0.85rem',*/}
      {/*          }}*/}
      {/*        >*/}
      {/*          Please proceed to the Front Desk to issue a digital pass to your*/}
      {/*          phone.*/}
      {/*        </Typography>*/}
      {/*      </Box>*/}

      {/*      <Typography*/}
      {/*        variant="caption"*/}
      {/*        sx={{*/}
      {/*          color: 'text.disabled',*/}
      {/*          fontWeight: 600,*/}
      {/*          fontSize: isSmallMobile ? '0.65rem' : '0.75rem',*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        NUVE SECURE ACCESS SYSTEM*/}
      {/*      </Typography>*/}
      {/*    </Stack>*/}
      {/*  </Paper>*/}
      {/*</Fade>*/}
    </Box>
  );
};

export default RegistrationRequiredPage;
